import React, { useContext } from 'react';

import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import { StaticContext } from '@sm/webassets/StaticContext';

import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';

import useStyles from './useStyles';

export type BackgroundColorProp = 'dark1' | 'dark2' | 'light1' | 'light2';
type TextColorProp = 'dark' | 'light';

export type Props = {
  backgroundColor?: BackgroundColorProp;
  ctaText: string;
  heading?: string;
  route: string;
  subheading?: string;
  utSource: string;
  utSource2: string;
};

export default function TextBanner({
  backgroundColor = 'dark1',
  ctaText,
  heading,
  route,
  subheading,
  utSource,
  utSource2,
}: Props): React.ReactElement {
  const utSource3 = 'TextBanner';
  const { container, headingText, subheadingText } = useStyles({ backgroundColor });
  const {
    smParams: { surveyId, collectorId, respondentId },
    templateType,
  } = useContext(StaticContext);
  const textColor: TextColorProp = backgroundColor.startsWith('dark') ? 'light' : 'dark';
  return (
    <Box className={container} display="flex" flexAlign="center" flexDirection="column" px={5} py={7}>
      <Grid noBleeds noGutters mb={5}>
        <Grid.Item lg={3} md={1}>
          <></>
        </Grid.Item>
        <Grid.Item lg={6} md={10} xs={12}>
          <>
            {heading && (
              <Box data-testid="TextBanner__Heading" pb={2}>
                <Typography align="center" color={textColor} variant="cardTitle">
                  <span className={headingText}>{heading}</span>
                </Typography>
              </Box>
            )}
            {subheading && (
              <Typography align="center" color={textColor} variant="body">
                <span className={subheadingText}>{subheading}</span>
              </Typography>
            )}
          </>
        </Grid.Item>
        <Grid.Item lg={3} md={1}>
          <></>
        </Grid.Item>
      </Grid>
      <Button
        color={backgroundColor.startsWith('dark') ? 'alt' : 'upgrade'}
        href={createURL(route, {
          ut_source: utSource,
          ut_source2: utSource2,
          ut_source3: utSource3,
          ut_ctatext: ctaText,
        })}
        size="lg"
        data-sm-metrics={generateMetricsAttribute({
          data: {
            amplitudeEvent: 'endpage user interaction',
            itemSelected: ctaText,
            templateType,
            surveyId,
            collectorId,
            respondentId,
            actionType: 'click-url',
            actionFlow: 'survey-endpage',
            log: {
              message: `${utSource}-${utSource2}-${utSource3}-${ctaText}`,
            },
          },
        })}
      >
        {ctaText}
      </Button>
    </Box>
  );
}
